import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { getCertificateRequests } from 'features/paperwork/certificadoAPI';
import { useUser } from 'context';
import { CertificadoEtica as CertificadoEticaType, getEstadoLabel } from 'types/Paperwork';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import config from 'config';

export default function CertificadoEtica() {
  const { getMatricula } = useUser();

  const [data, setData] = useState<CertificadoEticaType[]>([]);

  const [showAlert, message, alert] = useAlert(false, '');

  useEffect(() => {
    const matricula = getMatricula();
    if (!matricula) {
      console.error('No se pudo obtener la matrícula del usuario');
      return;
    }

    getCertificateRequests(parseInt(matricula, 10))
      .then(response => {
        setData(response);
      })
      .catch(err => {
        alert(true, err.getMessage() || 'No se puedieron obtener los pedidos del matriculado');
      });
  }, []);

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Certificados de Ética</Col>
                <Col md={4} className="text-right">
                  <Link
                    to={{ pathname: '/tramites/certificado-etica/solicitar' }}
                    className="btn btn-primary btn-round"
                  >
                    Nueva solicitud
                  </Link>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Fecha de Solicitud</th>
                    <th>Motivo</th>
                    <th>Validez</th>
                    <th>Estado</th>
                    <th>Descargar</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    data.map(row => (
                      <Fragment key={ `row_${ row.id }` }>
                        <tr style={ row.state_id === 3 ? { borderBottom: 'transparent' } : {} }>
                          <td>{ row.id }</td>
                          <td>{ row.date.split('-').reverse().join('/') }</td>
                          <td>{ row.reason }</td>
                          <td>{ row.validity || '-' }</td>
                          <td>{ getEstadoLabel(row.state_id) }</td>
                          <td>{
                            row.url
                              ? <a
                                  href={`${config.baseUrl}/${row.url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  aria-label="Decargar"
                                  style={{ fontSize: '1rem' }}
                                >
                                  <i className="far fa-file-pdf"></i>
                                </a>
                              : null
                          }</td>
                        </tr>
                        {
                          row.state_id === 3 // Rechazado
                            ? <tr>
                                <td></td>
                                <td colSpan={5}>Motivo de rechazo: { row.rejection_text }</td>
                              </tr>
                            : null
                        }
                      </Fragment>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
